export default function Add() {
  return (
    <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="AddIcon">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
    </svg>
  );
}
